// index.js or main file
import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import UserRules from './pages/rules/rules';
import Lobby from './pages/lobby/lobby';
import Host from './pages/host/host';
import QuizUI from './pages/quiz/quizUI';
import QuestionsTable from './admin/pages/questions/questions';
import AdminLobby from './admin/pages/lobby/lobby';
import SpaceGameSettings from './admin/pages/spaceGameSettings/spaceGameSettings';
import AdminLeaderboard from './admin/pages/leaderboard/leaderboard';
import ThankYou from './pages/thankyou/thankyou';
import USER from './pages/dddUI/user';
import JengaGame from './pages/jenga/JengaGame';
import Waiting from './pages/waiting/waiting';
import Leaderboard from './pages/leaderboard/leaderboard';
import Game from './pages/game/game';
import Modes from './pages/modes/modes';
import SpaceGame from './pages/spacegame/SpaceGame';
import Character from './pages/character/character';
import Play from './pages/play/play';

// PulsePlay 2.0 admin session builder
import SessionLayout from './admin/pages/sessionLayout/sessionLayout';
import ModeSelect from './admin/pages/modeSelect/modeSelect';
import SessionSettings from './admin/pages/sessionSettings/sessionSettings';
import ActivityBuilder from './admin/pages/activityBuilder/activityBuilder';
import QuizEditor from './admin/pages/quizEditor/quizEditor';
import PollEditor from './admin/pages/pollEditor/pollEditor';
import WordcloudEditor from './admin/pages/wordcloudEditor/wordcloudEditor';
import PindropEditor from './admin/pages/pindropEditor/pindropEditor';
import SessionReport from './admin/pages/sessionReport/sessionReport';
import Participants from './admin/pages/participants/participants';
import Presenter from './admin/pages/presenter/presenter';


function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    // /admin provides its own background. /play uses the SAME sitewide
    // background as /login and every other public route (common-bg) —
    // no custom background of its own.
    if (!location.pathname.startsWith("/admin")) {
      body.classList.add("common-bg");
    } else {
      body.classList.remove("common-bg");
    }
  }, [location]); 
}


function App() {
  usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Admin routes (no DDDUI wrapper) */}
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="questions" element={<Admin><QuestionsTable/></Admin>} />
          <Route path="lobby" element={<Admin><AdminLobby/></Admin>} />
          <Route path="spacegame-settings" element={<Admin><SpaceGameSettings/></Admin>} />
          <Route path="spacegame-leaderboard" element={<Admin><AdminLeaderboard/></Admin>} />
          <Route path="superadmin" element={<LoginPage/>} />

          {/* PulsePlay 2.0 session builder (tabbed layout) */}
          <Route path="session" element={<Admin><SessionLayout/></Admin>}>
            <Route index element={<Navigate to="activities" replace />} />
            <Route path="mode" element={<ModeSelect/>} />
            <Route path="settings" element={<SessionSettings/>} />
            <Route path="activities" element={<ActivityBuilder/>} />
            <Route path="review" element={<SessionReport/>} />
            <Route path="participants" element={<Participants/>} />
          </Route>

          {/* Full-screen focused content editors (outside the tab shell) */}
          <Route path="session/present" element={<Admin><Presenter/></Admin>} />
          <Route path="session/activities/quiz/:activityId" element={<Admin><QuizEditor/></Admin>} />
          <Route path="session/activities/poll/:activityId" element={<Admin><PollEditor/></Admin>} />
          <Route path="session/activities/wordcloud/:activityId" element={<Admin><WordcloudEditor/></Admin>} />
          <Route path="session/activities/pindrop/:activityId" element={<Admin><PindropEditor/></Admin>} />

          {/* Legacy flat routes -> redirect into the tabbed layout */}
          <Route path="mode-select" element={<Navigate to="/admin/session/mode" replace />} />
          <Route path="session-settings" element={<Navigate to="/admin/session/settings" replace />} />
          <Route path="activities" element={<Navigate to="/admin/session/activities" replace />} />
          <Route path="report" element={<Navigate to="/admin/session/review" replace />} />
        </Route>

        {/* Public routes wrapped with DDDUI */}
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/play" element={<Play/>} />
              <Route path="/rules" element={<UserRules/>} />
              <Route path="/character" element={<Character/>} />
              <Route path="/modes" element={<Modes/>} />
              <Route path="/mazegame" element={<SpaceGame/>} />
              <Route path="/lobby" element={<Lobby/>} />
              <Route path="/host" element={<Host/>} />
              <Route path="/quiz" element={<QuizUI/>} />
              <Route path="/jenga" element={<JengaGame/>} />
              <Route path="/leaderboard" element={<Leaderboard/>} />
              <Route path="/create-puzzle" element={<Navigate to="/host" replace />} />
              <Route path="/puzzle" element={<Navigate to="/game" replace />} />
              <Route path="/waiting" element={<Waiting/>} />
              <Route path="/game" element={<Game/>} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/thankyou" element={<ThankYou/>} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
